<template>
  <div>
    <WebHeaderView :title="'代理'" />
    <div class="page-content">
      <van-tabs
        @click="tabClick"
        v-model="active"
        color="#fff"
        title-active-color="#fff"
      >
        <van-tab title="收益" :name="1" />
        <van-tab title="团队" :name="2" />
      </van-tabs>
      <ProfitsView ref="ProfitsView" v-if="active == 1" />
      <TeamView ref="TeamView" v-if="active == 2" />
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
import { ProfitsView, TeamView } from './components/index'
export default {
  name: 'ProxyView',
  components: {
    WebHeaderView,
    ProfitsView,
    TeamView
  },
  data () {
    return {
      active: 1
    }
  },
  methods: {
    tabClick () {},
    InitPage(){},
    
  }
}
</script>
<style scoped>
.title {
  border-bottom: 2px solid #fff;
  text-align: left;
  height: 38px;
  line-height: 38px;
  width: 96%;
  margin: 20px auto 10px;
  font-size: 20px;
  font-weight: 700;
  text-indent: 8px;
}
</style>
